<script setup>
import Navbar from '@/layouts/partials/Navbar.vue'
import Footer from '@/layouts/partials/Footer.vue'
</script>

<template>
    <Navbar />

    <main class="min-h-screen mt-16 lg:mt-18">
        <slot />
    </main>

    <Footer />
</template>
